// extracted by mini-css-extract-plugin
module.exports = {"watchlistSetupContainer":"signedOutSetupWatchlist_watchlistSetupContainer__Cz8e0","logicalOperatorText":"signedOutSetupWatchlist_logicalOperatorText__YXu7F"};